module.exports = __webpack_public_path__ + "static/media/Undo.73054cdb.svg";